import { ReactElement } from 'react'
import { projectWall2D } from '@editorUtils'
import { ShapeMesh } from '@scene'
import { useTheme } from '@mui/material'
import { Line } from '@react-three/drei'
import { useFloorplanViewActive } from '@editorHooks'

interface Props {
  /** the walls as the wall form currently describes them (the saved ones are hidden) */
  walls: ShapeObject[]
}

// below the WallEdit line (z 80), above the floorplan walls
const floorplanZTranslation = 70

/**
 * Draws the walls of an open wall form in place of the hidden saved walls: in 3D like a selected
 * wall of the model, in the floorplan as a wall line.
 */
const WallFormSceneElement = ({ walls }: Props): ReactElement => {
  const { scenePalette } = useTheme()
  const floorplanViewActive = useFloorplanViewActive()

  if (floorplanViewActive)
    return (
      <group position={[0, 0, floorplanZTranslation]}>
        {walls.map(wall => {
          const [start, end] = projectWall2D(wall).points

          return (
            <Line
              key={wall.guid}
              points={[start.v, end.v]}
              color={
                (wall.placement === 'Internal'
                  ? scenePalette.elements2d.internalWalls.color
                  : scenePalette.elements2d.externalWalls.color) as string
              }
              lineWidth={3}
            />
          )
        })}
      </group>
    )

  return (
    <>
      {walls.map(wall => (
        <ShapeMesh
          key={wall.guid}
          data={wall}
          shapeColor={
            wall.placement === 'Internal'
              ? scenePalette.elements3d.internalWalls
              : scenePalette.elements3d.externalWalls
          }
          outlinesColor={scenePalette.highlightDark}
          outlines
          noPointerInteractions
        />
      ))}
    </>
  )
}

export default WallFormSceneElement
